var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-mask",on:{"click":_vm.click}},[_c('b-spinner',{attrs:{"label":"Spinning"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }